/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateUserRoleRequest interface.
 */
export function instanceOfUpdateUserRoleRequest(value) {
    return true;
}
export function UpdateUserRoleRequestFromJSON(json) {
    return UpdateUserRoleRequestFromJSONTyped(json, false);
}
export function UpdateUserRoleRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'expiresAt': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
    };
}
export function UpdateUserRoleRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'expires_at': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
    };
}
